<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <div >
      <div class="d-flex whitesmoke">
        <v-subheader class="justify-space-between subtitle-1 whitesmoke font-weight-medium grayBold--text">
          {{ $t("installations_info") }}
        </v-subheader>
      </div>
      <v-list class="whitesmoke tab" min-width="500px">
        <v-expansion-panels v-if="installationsExist" class="whitesmoke">
          <v-expansion-panel v-for="installation in clientInstallations" :key="installation.id" class="expansion">
            <v-expansion-panel-header class="whitesmoke expansion-header">
              <span class="expansion-item" width="40px">
                <v-icon
                  color="primary">
                  mdi-qrcode
                </v-icon>
                {{ installation.tag_id.split('_').pop() }}
              </span>
              <span class="expansion-item" width="40px">
                <v-icon
                  v-if="installation.is_premium"
                  color="success">
                  mdi-star-box-outline
                </v-icon>
              </span>
              <template v-slot:actions>
                <v-btn 
                  small
                  icon
                 >
                <v-icon
                  color="gray"
                  class="mr-1">
                  mdi-chevron-down
                </v-icon>
                </v-btn>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="whitesmoke">
              <v-list class="whitesmoke tab" min-width="500px">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="overline grayBold--text">
                      {{ $t("address") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="pt-1 grayBold--text"> {{installation.address}} </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="overline grayBold--text">
                      {{ $t("area_uppercase") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="pt-1 grayBold--text"> {{installation.area}} </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mx-4 mt-2"/>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="overline grayBold--text">
                      {{ $t("floor_uppercase") }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="pt-1 grayBold--text"> {{installation.floor}} </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-btn elevation="3" outlined color="grey darken-2" @click="openInstallation(installation.id)">{{$t('installationOpenBtn')}}
                <v-icon
                  class="mr-1">
                  mdi-open-in-new
                </v-icon>
              </v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-list-item v-else>
          <v-list-item-content>
            <v-list-item-subtitle class="pt-1 grayBold--text"> {{$t("installationsEmpty")}} </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      </div>
  </template>
  
  
  <script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
  import { commonModule, installationsModule, clientsModule } from '@/store/modules/store-accessor'
  import { TimeUtil } from '@/helpers/TimeUtil'
  
  @Component
  export default class ClientsSideviewInstallationsTab extends Vue {
   @Prop() client: Record<string, any>;
  
    formatDate (date: Date): string {
      return TimeUtil.formatDateTime(date)
    }
  
    get installationsExist() {
      return this.client.installations.length > 0
    }
  
    get clientInstallations() {
      return this.client.installations;
    }
  
    async openInstallation(installationId: any) {
      await installationsModule.getInstallationInfo(installationId);
      clientsModule.unsetCurrentClient();
      commonModule.showSideview({ name: 'installations-sideview' , payload: { installationId: installationId} })
    }
  
  };
  </script>
  
  <style scoped lang="scss">
  .tab {
    max-height: calc(70vh - 250px) !important;
    overflow-y: auto;
  }
  
  div { 
      width:100%;
  }
  
  .expansion{
    color: whitesmoke;
  }
  
  .expansion-item {
    flex: 1 1 0 !important;
  }
</style>
  